export const KIOSK = 'kiosk';

export const TIMEOUT = 35_000;
export const PROMPT_BEFORE_IDLE = 9_000;
export const ACTIVE = 'Active';
export const PROMPTED = 'Prompted';
export const IDLE = 'Idle';

// local storage keys
export const KIOSK_REDIRECT_URL = 'redirect_url';
export const KIOSK_COMPANY_ID = 'company_id';
export const KIOSK_TERMINAL_ID = 'terminal_id';

//reducer actions
export const EDIT_KIOSK_COMPANY_ID = 'EDIT_KIOSK_COMPANY_ID';
export const EDIT_KIOSK_TERMINAL_ID = 'EDIT_KIOSK_TERMINAL_ID';
export const EDIT_KIOSK_REDIRECT_URL = 'EDIT_KIOSK_REDIRECT_URL';
export const CLEAR_KIOSK_KEYS = 'CLEAR_KIOSK_KEYS';
export const CACHE_STOREFRONT_IMAGES = 'CACHE_STOREFRONT_IMAGES';

// Manage Kiosk Views
export const OVERVIEW = 'OVERVIEW';
export const LOCATION = 'LOCATION';
export const READERS = 'READERS';
export const STORE_CODE = 'STORE_CODE';
export const FAQ = 'FAQ';
